import { AddRoundedIcon, Button } from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { ExaminationCourseCreationModal } from '../examination-course-creation-modal';

export default function ExaminationCourseCreationButton() {
  const [isExaminationCourseCreationModalOpen, examinationCourseCreationModalHandlers] =
    useDisclosure();

  const { close: closeExaminationCourseCreationModal, open: openExaminationCourseCreationModal } =
    examinationCourseCreationModalHandlers;

  const handleOpen = () => {
    openExaminationCourseCreationModal();
  };

  return (
    <>
      <Button startIcon={<AddRoundedIcon />} onClick={handleOpen} size='large'>
        Create Examination Course
      </Button>
      <ExaminationCourseCreationModal
        open={isExaminationCourseCreationModalOpen}
        onClose={closeExaminationCourseCreationModal}
      />
    </>
  );
}
